// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewsLetter_container__oeNws {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    background-color: #1a1a1a;
    margin-top: 1rem;
  }
  
  .NewsLetter_overlay__96vsJ {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 20px;
  }
  
  .NewsLetter_newsletterBox__Ye95S {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 40px;
    width: 100%;
    max-width: 600px;
    position: relative;
    overflow: hidden;
  }
  
  .NewsLetter_content__61rHo {
    position: relative;
    z-index: 2;
  }
  
  .NewsLetter_title__LIuuW {
    font-size: 2.5rem;
    color: white;
    margin: 0 0 16px 0;
    font-weight: 800;
    text-align: center;
    letter-spacing: -0.5px;
  }
  
  .NewsLetter_subtitle__LWZVm {
    font-size: 1.1rem;
    color: rgba(255, 255, 255, 0.8);
    margin: 0 0 32px 0;
    text-align: center;
    line-height: 1.6;
  }
  
  .NewsLetter_form__IfgJT {
    width: 100%;
    margin-bottom: 24px;
  }
  
  .NewsLetter_inputWrapper__kjPcx {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
    position: relative;
  }
  
  .NewsLetter_input__RQPQD {
    flex: 1 1;
    padding: 16px 24px;
    border: 2px solid rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    font-size: 1rem;
    color: white;
    transition: all 0.3s ease;
  }
  
  .NewsLetter_input__RQPQD::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
  
  .NewsLetter_input__RQPQD:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.15);
  }
  
  .NewsLetter_button__A2p0l {
    padding: 16px 32px;
    background: linear-gradient(45deg, #FF6B6B, #FF8E53);
    border: none;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .NewsLetter_button__A2p0l:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
  }
  
  .NewsLetter_buttonIcon__GUI6U {
    transition: transform 0.3s ease;
  }
  
  .NewsLetter_button__A2p0l:hover .NewsLetter_buttonIcon__GUI6U {
    transform: translateX(4px);
  }
  
  .NewsLetter_successMessage__ldLzq {
    color: #4CAF50;
    background: rgba(76, 175, 80, 0.1);
    padding: 12px;
    border-radius: 8px;
    text-align: center;
    margin-top: 16px;
  }
  
  .NewsLetter_errorMessage__iE3S1 {
    color: #FF6B6B;
    background: rgba(255, 107, 107, 0.1);
    padding: 12px;
    border-radius: 8px;
    text-align: center;
    margin-top: 16px;
  }
  
  .NewsLetter_disclaimer__4iN2E {
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.9rem;
    text-align: center;
    margin: 0;
  }
  
  @media (max-width: 768px) {
    .NewsLetter_newsletterBox__Ye95S {
      padding: 30px;
    }
  
    .NewsLetter_title__LIuuW {
      font-size: 2rem;
    }
  
    .NewsLetter_subtitle__LWZVm {
      font-size: 1rem;
    }
  }
  
  @media (max-width: 480px) {
    .NewsLetter_inputWrapper__kjPcx {
      flex-direction: column;
    }
  
    .NewsLetter_button__A2p0l {
      width: 100%;
      justify-content: center;
    }
  
    .NewsLetter_title__LIuuW {
      font-size: 18px;
    }
    .NewsLetter_subtitle__LWZVm{
      font-size: 12px;
    }
    .NewsLetter_button__A2p0l{
      font-size: 12px;
    }
 .NewsLetter_overlay__96vsJ{
  padding: 10px 20px;
 }
 .NewsLetter_newsletterBox__Ye95S{
  padding: 10px;
 }
  }`, "",{"version":3,"sources":["webpack://./src/common/UI/CSS/NewsLetter.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,0CAA0C;IAC1C,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,sCAAsC;IACtC,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;IAClB,oDAAoD;IACpD,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,2BAA2B;IAC3B,+CAA+C;EACjD;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,kCAAkC;IAClC,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,oCAAoC;IACpC,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;MACX,uBAAuB;IACzB;;IAEA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;CACH;EACC,kBAAkB;CACnB;CACA;EACC,aAAa;CACd;EACC","sourcesContent":[".container {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-size: cover;\n    background-position: center;\n    background-attachment: fixed;\n    background-color: #1a1a1a;\n    margin-top: 1rem;\n  }\n  \n  .overlay {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 40px 20px;\n  }\n  \n  .newsletterBox {\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 20px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    padding: 40px;\n    width: 100%;\n    max-width: 600px;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .content {\n    position: relative;\n    z-index: 2;\n  }\n  \n  .title {\n    font-size: 2.5rem;\n    color: white;\n    margin: 0 0 16px 0;\n    font-weight: 800;\n    text-align: center;\n    letter-spacing: -0.5px;\n  }\n  \n  .subtitle {\n    font-size: 1.1rem;\n    color: rgba(255, 255, 255, 0.8);\n    margin: 0 0 32px 0;\n    text-align: center;\n    line-height: 1.6;\n  }\n  \n  .form {\n    width: 100%;\n    margin-bottom: 24px;\n  }\n  \n  .inputWrapper {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 16px;\n    position: relative;\n  }\n  \n  .input {\n    flex: 1;\n    padding: 16px 24px;\n    border: 2px solid rgba(255, 255, 255, 0.2);\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n    font-size: 1rem;\n    color: white;\n    transition: all 0.3s ease;\n  }\n  \n  .input::placeholder {\n    color: rgba(255, 255, 255, 0.6);\n  }\n  \n  .input:focus {\n    outline: none;\n    border-color: rgba(255, 255, 255, 0.5);\n    background: rgba(255, 255, 255, 0.15);\n  }\n  \n  .button {\n    padding: 16px 32px;\n    background: linear-gradient(45deg, #FF6B6B, #FF8E53);\n    border: none;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 600;\n    color: white;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);\n  }\n  \n  .buttonIcon {\n    transition: transform 0.3s ease;\n  }\n  \n  .button:hover .buttonIcon {\n    transform: translateX(4px);\n  }\n  \n  .successMessage {\n    color: #4CAF50;\n    background: rgba(76, 175, 80, 0.1);\n    padding: 12px;\n    border-radius: 8px;\n    text-align: center;\n    margin-top: 16px;\n  }\n  \n  .errorMessage {\n    color: #FF6B6B;\n    background: rgba(255, 107, 107, 0.1);\n    padding: 12px;\n    border-radius: 8px;\n    text-align: center;\n    margin-top: 16px;\n  }\n  \n  .disclaimer {\n    color: rgba(255, 255, 255, 0.6);\n    font-size: 0.9rem;\n    text-align: center;\n    margin: 0;\n  }\n  \n  @media (max-width: 768px) {\n    .newsletterBox {\n      padding: 30px;\n    }\n  \n    .title {\n      font-size: 2rem;\n    }\n  \n    .subtitle {\n      font-size: 1rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .inputWrapper {\n      flex-direction: column;\n    }\n  \n    .button {\n      width: 100%;\n      justify-content: center;\n    }\n  \n    .title {\n      font-size: 18px;\n    }\n    .subtitle{\n      font-size: 12px;\n    }\n    .button{\n      font-size: 12px;\n    }\n .overlay{\n  padding: 10px 20px;\n }\n .newsletterBox{\n  padding: 10px;\n }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewsLetter_container__oeNws`,
	"overlay": `NewsLetter_overlay__96vsJ`,
	"newsletterBox": `NewsLetter_newsletterBox__Ye95S`,
	"content": `NewsLetter_content__61rHo`,
	"title": `NewsLetter_title__LIuuW`,
	"subtitle": `NewsLetter_subtitle__LWZVm`,
	"form": `NewsLetter_form__IfgJT`,
	"inputWrapper": `NewsLetter_inputWrapper__kjPcx`,
	"input": `NewsLetter_input__RQPQD`,
	"button": `NewsLetter_button__A2p0l`,
	"buttonIcon": `NewsLetter_buttonIcon__GUI6U`,
	"successMessage": `NewsLetter_successMessage__ldLzq`,
	"errorMessage": `NewsLetter_errorMessage__iE3S1`,
	"disclaimer": `NewsLetter_disclaimer__4iN2E`
};
export default ___CSS_LOADER_EXPORT___;
